import React from 'react';
import './Work.css'
const Work=(props)=> {
    return (
        <div>
            
        </div>
    );
}

export default Work;